import { MemIntegrationRepository } from '@infra/repositories/integration-mem.repository';
import { MemCallRepository } from '@infra/repositories/mem-call.repository';
import { MemParticipantRepository } from '@infra/repositories/mem-participant.repository';
import { MemAgentRepository } from '@infra/repositories/mem-agent.repositary';
import { MemTeamRepository } from '@infra/repositories/mem-team.repository';
import { MemUserRepository } from '@infra/repositories/mem-user.repository';
import { MemTagRepository } from '@infra/repositories/mem-tag.repository';

export class RepositoryFactory {
  private static memCallRepository: MemCallRepository;

  static buildMemCallRepository(): MemCallRepository {
    if (!this.memCallRepository) {
      this.memCallRepository = new MemCallRepository();
    }

    return this.memCallRepository;
  }

  private static memUserRepository: MemUserRepository;
  static buildMemUserRepository(): MemUserRepository {
    return (
      this.memUserRepository ??
      (this.memUserRepository = new MemUserRepository())
    );
  }

  private static memParticipantRepository: MemParticipantRepository;
  static buildMemParticipantRepository(): MemParticipantRepository {
    return (
      this.memParticipantRepository ??
      (this.memParticipantRepository = new MemParticipantRepository())
    );
  }

  private static memIntegrationRepository: MemIntegrationRepository;
  static buildMemIntegrationRepository(): MemIntegrationRepository {
    return (
      this.memIntegrationRepository ??
      (this.memIntegrationRepository = new MemIntegrationRepository())
    );
  }

  private static memAgentRepository: MemAgentRepository;
  static buildMemAgentRepository(): MemAgentRepository {
    return (
      this.memAgentRepository ??
      (this.memAgentRepository = new MemAgentRepository())
    );
  }

  private static memTeamRepository: MemTeamRepository;
  static buildMemTeamRepository(): MemTeamRepository {
    return (
      this.memTeamRepository ??
      (this.memTeamRepository = new MemTeamRepository())
    );
  }

  private static memTagRepository: MemTagRepository;
  static buildMemTagRepository(): MemTagRepository {
    return (
      this.memTagRepository ?? (this.memTagRepository = new MemTagRepository())
    );
  }
}
